import { Autocomplete, TextField } from "@mui/material";
import { useContext } from "react";
import CurrencyContext from "../../store/CurrencyContext";
import i18next from "../i18n/i18n";
import { useTranslation } from "react-i18next";

const LanguageSelector = () => {
  const currencyCtx = useContext(CurrencyContext);
  const currentLang = currencyCtx.languageParentWindow;
  const { t } = useTranslation('common');

  const options = [
    { code: 'en', label: 'English' },
    { code: 'fr', label: 'Français' }
  ];

  const selectedOption = options.find(opt => opt.code === currentLang);

  const handleChange = (_event, newValue) => {
    if (!newValue) return;
    i18next.changeLanguage(newValue.code);
    if (currencyCtx.changeLanguage) {
      currencyCtx.changeLanguage(newValue.code); // update context
    }
  };

  return (
    <Autocomplete
      disablePortal
      id="language-selector"
      options={options}
      value={selectedOption}
      onChange={handleChange}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      getOptionLabel={(option) => option.label}
      sx={{ width: 150 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('language.choose') || "Langue"}
          style={{ textAlign: "left", color: "black" }}
        />
      )}
    />
  );
};

export default LanguageSelector;
